import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} DANI IMPORT&EXPORT TRADING. All rights reserved.</p>
        <p className="developer">
          Designed and Developed by{' '}
          <a
            href="https://t.me/codeBiruh"
            target="_blank"
            rel="noopener noreferrer"
          >
            CODEBIRUH
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
